export default __webpack_public_path__ + "static/media/Emojis01.8184b75a.png";